"use client";

import React from "react";
import { Modal } from "antd";

export type DesktopBookingDrawerProps = {
  /** Whether the modal is open. */
  open: boolean;
  /** Called when the modal should close. */
  onClose: () => void;
  children: React.ReactNode;
};

/**
 * Desktop appointment overlay — uses Ant Design Modal,
 * matching the original ResponsiveDialog pattern on desktop.
 */
export function DesktopBookingDrawer({
  open,
  onClose,
  children,
}: DesktopBookingDrawerProps) {
  return (
    <Modal
      title="Book an appointment"
      open={open}
      maskClosable={false}
      onCancel={onClose}
      footer={null}
      style={{ top: 20 }}
      // The modal portals to document.body, outside any themed wrapper's
      // inline CSS vars. This class lets a theme root re-scope its vars to
      // the portal (EditorialBookingPageRoot does); where nothing targets
      // it, it is inert.
      rootClassName="openings-booking-portal"
      destroyOnHidden
    >
      {children}
    </Modal>
  );
}
